<section class="site-contacts">
  <iot-platform-ui-panel
    [buttonTooltip]="'SITES.CONTACT_FORM.ADD' | translate"
    [hasButton]="false"
    [title]="'SITES.CONTACT_FORM.PANEL_TITLE' | translate"
    [withCustomAction]="true"
    class="mt-4 mb-4"
  >
    <div fxFlexLayout="row" fxLayoutAlign="center center" panelCustomAction>
      @if (contacts?.length > 3 || (contacts?.length > 2 && canAddContact)) {
        <div
          [matTooltip]="(horizontalLayout ? 'PANELS.TOOLTIPS.HORIZONTAL_LAYOUT' : 'PANELS.TOOLTIPS.VERTICAL_LAYOUT') | translate"
          class="panel-button app-round-button"
          matTooltipClass="regular-tooltip"
        >
          <button (click)="horizontalLayout = !horizontalLayout" fxHide.lt-md mat-icon-button>
            <mat-icon>{{ horizontalLayout ? 'apps' : 'swap_horiz' }}</mat-icon>
          </button>
        </div>
      }
      @if (canUpdateSite && canAddContact) {
        <div [matTooltip]="'SITES.CONTACT_FORM.ADD' | translate" class="panel-button app-round-button site-contacts__btn-add" matTooltipClass="regular-tooltip">
          <button (click)="onAddContact()" mat-icon-button>
            <mat-icon>add</mat-icon>
          </button>
        </div>
      }
    </div>
    @if (loading) {
      <div fxFlexLayout="row" fxLayoutAlign="center center" panelGrid style="width: 100%">
        <mat-progress-spinner [diameter]="50" color="accent" mode="indeterminate"></mat-progress-spinner>
      </div>
    } @else if (!hasContacts) {
      <ng-container panelGrid>
        <div class="no-data-message" fxFlexAlign="center center" fxFlexLayout="row">
          <p>{{ 'SITES.CONTACT_FORM.NO_CONTACTS' | translate }}</p>
        </div>
      </ng-container>
    } @else {
      <iot-platform-ui-cards-container [horizontalLayout]="horizontalLayout" panelGrid>
        @for (contact of contacts; track contact) {
          <oyan-ui-contact-card
            (dispatchEvent)="onDispatchEvent($event)"
            [canDelete]="canDeleteContact"
            [canUpdateSite]="canUpdateSite"
            [canUpdate]="canUpdateContact"
            [element]="contact"
            class="card-sm"
            fxFlex.lt-md="100%"
          ></oyan-ui-contact-card>
        }
        @if (canUpdateSite && canAddContact) {
          <iot-platform-ui-default-card
            (click)="onAddContact()"
            [backgroundClass]="'h-100'"
            [title]="'SITES.CONTACT_FORM.ADD' | translate"
            [withCustomButton]="false"
            [icon]="'add'"
            class="card-sm"
            fxFlex.lt-md="100%"
          >
          </iot-platform-ui-default-card>
        }
      </iot-platform-ui-cards-container>
    }
  </iot-platform-ui-panel>
</section>
